import React, { useEffect, useRef } from "react"

interface CognitoEntry {
  [key: string]: any
}

interface CognitoResponse {
  data: {
    entry: CognitoEntry
  }
}

declare const Cognito: {
  on: (event: string, callback: (response: CognitoResponse) => void) => void
}

interface CognitoFormComponentProps {
  formData: {
    formId: string
  }
  productData: {
    sku: string
    Trial_Duration: number
  }
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
  setError: React.Dispatch<React.SetSateAction<boolean>>
  setErrorText: React.Dispatch<React.SetStateAction<string>>
  startTrial: (
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
    setError: React.Dispatch<React.SetStateAction<boolean>>,
    setErrorText: React.Dispatch<React.SetStateAction<string>>,
    sku?: string,
    trialDuration?: number
  ) => void
  submitToWorkato: (values: CognitoEntry) => void
}

export const CognitoFormComponent: React.FC<CognitoFormComponentProps> = ({
  formData,
  setLoading,
  setError,
  setErrorText,
  productData,
  submitToWorkato,
  startTrial,
}) => {
  const formContainerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!formContainerRef.current || formContainerRef.current.hasChildNodes()) {
      return
    }

    const setupForm = () => {
      Cognito.on("afterSubmit", function (response) {
        startTrial(
          setLoading,
          setError,
          setErrorText,
          productData?.sku,
          productData?.Trial_Duration
        )

        const vals = response?.data?.entry
        if (vals) {
          submitToWorkato(vals, productData?.sku)
        }
      })
    }

    const script = document.createElement("script")
    script.src = "https://www.cognitoforms.com/f/seamless.js"
    script.setAttribute("data-key", "0cXQNplKOk-LZ2g6xRL5fQ")
    script.setAttribute("data-form", formData?.formId)
    script.onload = () => setupForm()

    formContainerRef.current.appendChild(script)
  }, [
    formData,
    productData,
    setLoading,
    setError,
    setErrorText,
    startTrial,
    submitToWorkato,
  ])
  console.log(formData?.header)
  return <div className="trial-cognito" ref={formContainerRef} />
}
